import React from 'react';

export const DashboardMainSkeleton = () => (
    <div className="dashboard-skeleton mt-2">
        <div className="row g-3 mb-3">
            {[
                { key: 'clientes', title: 'CLIENTES', badge: 'CLI', subtitle: 'Activos en plataforma', tone: 'bg-soft-primary' },
                { key: 'proyectos', title: 'PROYECTOS', badge: 'PRJ', subtitle: 'Portafolio vigente', tone: 'bg-soft-info' },
                { key: 'grupos', title: 'GRUPOS', badge: 'GRP', subtitle: 'Equipos configurados', tone: 'bg-soft-secondary' },
                { key: 'tickets', title: 'TICKETS', badge: 'TKT', subtitle: 'En el período seleccionado', tone: 'bg-soft-warning' },
                { key: 'abiertos', title: 'ABIERTOS', badge: 'OPN', subtitle: 'Pendientes por atender', tone: 'bg-soft-danger' },
                { key: 'cerrados', title: 'CERRADOS', badge: 'CLS', subtitle: 'Resueltos en período', tone: 'bg-soft-success' },
            ].map((item) => (
                <div className="col-12 col-md-6 col-xl-2" key={`dashboard-kpi-skeleton-${item.key}`}>
                    <div className={`card card-body border dashboard-kpi-card dashboard-kpi-card--compact ${item.tone}`}>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <div className="fs-12 text-muted text-uppercase">{item.title}</div>
                            <span className="badge bg-white text-secondary">{item.badge}</span>
                        </div>
                        <span className="ticket-skeleton-line d-block mb-2" style={{ width: '68px', height: '30px' }} />
                        <div className="text-muted fs-11 mt-1">{item.subtitle}</div>
                    </div>
                </div>
            ))}
        </div>

        <div className="row g-3 mb-3">
            {[
                { key: 'tickets', title: 'VARIACIÓN TICKETS' },
                { key: 'abiertos', title: 'VARIACIÓN ABIERTOS' },
                { key: 'cerrados', title: 'VARIACIÓN CERRADOS' },
            ].map((item) => (
                <div className="col-12 col-lg-4" key={`dashboard-variation-skeleton-${item.key}`}>
                    <div className="card card-body border dashboard-variation-card">
                        <div className="fs-12 text-muted text-uppercase mb-1">{item.title}</div>
                        <div className="d-flex align-items-end justify-content-between">
                            <span className="ticket-skeleton-line d-block" style={{ width: '56px', height: '24px' }} />
                            <span className="ticket-skeleton-line d-block" style={{ width: '52px', height: '16px' }} />
                        </div>
                        <div className="text-muted fs-11 mt-1">vs período anterior</div>
                    </div>
                </div>
            ))}
        </div>

        <div className="row g-3">
            <div className="col-12 col-xl-6">
                <div className="card card-body border h-100">
                    <h6 className="mb-3">Tickets por estatus</h6>
                    {['Nuevo', 'Abierto', 'En progreso', 'Espera cliente', 'Resuelto'].map((label) => (
                        <div className="mb-2" key={`status-skeleton-${label}`}>
                            <div className="d-flex justify-content-between fs-12 mb-1">
                                <span>{label}</span>
                                <span className="ticket-skeleton-line d-inline-block" style={{ width: '32px', height: '12px' }} />
                            </div>
                            <span className="ticket-skeleton-line d-block" style={{ width: '100%', height: '8px' }} />
                        </div>
                    ))}
                </div>
            </div>

            <div className="col-12 col-xl-6">
                <div className="card card-body border h-100">
                    <h6 className="mb-3">Tendencia de tickets creados</h6>
                    <span className="ticket-skeleton-line d-block" style={{ width: '100%', height: '170px', borderRadius: '12px' }} />
                </div>
            </div>

            <div className="col-12 col-xl-6">
                <div className="card card-body border h-100">
                    <h6 className="mb-3">Tickets por prioridad</h6>
                    {['Baja', 'Media', 'Alta', 'Urgente', 'Crítica'].map((label) => (
                        <div className="mb-2" key={`priority-skeleton-${label}`}>
                            <div className="d-flex justify-content-between fs-12 mb-1">
                                <span>{label}</span>
                                <span className="ticket-skeleton-line d-inline-block" style={{ width: '32px', height: '12px' }} />
                            </div>
                            <span className="ticket-skeleton-line d-block" style={{ width: '100%', height: '8px' }} />
                        </div>
                    ))}
                </div>
            </div>

            <div className="col-12 col-xl-6">
                <div className="card card-body border h-100">
                    <h6 className="mb-3">Top proyectos con más tickets</h6>
                    <div className="table-responsive">
                        <table className="table table-sm align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Proyecto</th>
                                    <th>Código</th>
                                    <th className="text-end">Tickets</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.from({ length: 4 }).map((_, row) => (
                                    <tr key={`top-project-skeleton-${row}`}>
                                        <td><span className="ticket-skeleton-line d-block" style={{ width: '80%', height: '14px' }} /></td>
                                        <td><span className="ticket-skeleton-line d-block" style={{ width: '56%', height: '14px' }} /></td>
                                        <td className="text-end"><span className="ticket-skeleton-line d-inline-block" style={{ width: '34px', height: '14px' }} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
